import { useDeviceSelectionDeviceListCoCo } from '../../../common/hooks/useDeviceSelectionDeviceListCoCo.js';
import { noResultsFoundMsg, t } from '../../../common/i18n/index.js';
import { getDeviceSelectionDevices } from '../../../common/utils/deviceSelectionDeviceUtilsCoCo.js';
import { DeviceSelectionDevicesTableCoCo } from './DeviceSelectionDevicesTableCoCo.js';
import { DeviceSelectionDevicesToolbarCoCo } from './DeviceSelectionDevicesToolbarCoCo.js';
import type { DeviceSelectionCategoryCoCo } from '../../../common/enums.js';
import type { DeviceSelectionDeviceCoCo } from '../../../common/utils/deviceSelectionDeviceUtilsCoCo.js';

import './DeviceSelectionDeviceListCoCo.scss';

interface DeviceSelectionDeviceListContentCoCoProps {
  name: string;
  devices: DeviceSelectionDeviceCoCo[];
}

const DeviceSelectionDeviceListContentCoCo = ({ name, devices }: DeviceSelectionDeviceListContentCoCoProps) => {
  const { filters, search, sort, setFilters, setSearch, setSort, showSelectedFirst, visibleDevices } =
    useDeviceSelectionDeviceListCoCo(devices, name);
  return (
    <>
      <DeviceSelectionDevicesToolbarCoCo
        filters={filters}
        search={search}
        sort={sort}
        onFiltersChange={setFilters}
        onSearchChange={setSearch}
        onSortChange={setSort}
        onShowSelectedFirst={showSelectedFirst}
      />
      {visibleDevices.length > 0 ? (
        <DeviceSelectionDevicesTableCoCo name={name} devices={visibleDevices} />
      ) : (
        <p className="of-device-selection-device-list-coco__empty">{t.OQBT(noResultsFoundMsg)}</p>
      )}
    </>
  );
};

interface DeviceSelectionDeviceListCoCoProps {
  name: string;
  category?: DeviceSelectionCategoryCoCo;
  devices: DeviceSelectionDeviceCoCo[];
}

export const DeviceSelectionDeviceListCoCo = ({ name, category, devices }: DeviceSelectionDeviceListCoCoProps) => {
  const categoryDevices = getDeviceSelectionDevices(category, devices);
  if (!category) {
    return null;
  }
  if (categoryDevices.length === 0) {
    return <p className="of-device-selection-device-list-coco__empty">{t.TR6I('No devices in this category.')}</p>;
  }
  // Reset the toolbar when the category changes, keeping form selections across categories.
  return <DeviceSelectionDeviceListContentCoCo key={category} name={name} devices={categoryDevices} />;
};
